import { SESSION_AGE } from "constants/vars";

// Amount Conversions
export const centsToRands = function (amount) {
  const randAmount = amount / 100;
  return randAmount.toFixed(2);
};

export const unslugify = (slug) => {
  const result = slug.replace(/_/g, " ");
  return result.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const substringDate = function (date) {
  var dateLength = date.length;
  return date.substring(0, dateLength - 3);
};

export const getNowTime = function () {
  var nowDate = new Date();
  var minutes = nowDate.getMinutes().toString();
  var hours = nowDate.getHours().toString();
  if (minutes.length === 1) {
    minutes = "0" + minutes;
  }
  if (hours.length === 1) {
    hours = "0" + hours;
  }
  return hours + ":" + minutes;
};

export const parseJwt = (token) => {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(""),
  );

  return JSON.parse(jsonPayload);
};

export const isTokenExpired = (idToken, sessionAge = SESSION_AGE) => {
  const authTime = parseJwt(idToken).auth_time;
  const now = new Date();
  const secondsSinceEpoch = Math.round(now.getTime() / 1000);
  const isExpired = secondsSinceEpoch - authTime > sessionAge ? true : false;
  return isExpired;
};

export const componentLoader = (
  lazyComponent,
  attemptsLeft = 5,
  timeout = 500,
) => {
  return new Promise((resolve, reject) => {
    lazyComponent()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (attemptsLeft === 1) {
            reject(error);
            return;
          }
          componentLoader(lazyComponent, attemptsLeft - 1, timeout).then(
            resolve,
            reject,
          );
        }, timeout);
      });
  });
};
